// constants
export const TRACKERS_SHEET_OPEN = 'TRACKERS_SHEET_OPEN';
export const TRACKERS_SHEET_CLOSE = 'TRACKERS_SHEET_CLOSE';

export const openTrackerSheet = (options) => ({
  type: TRACKERS_SHEET_OPEN,
  payload: { isOpen: true, trackerType: options.trackerType },
});

export const closeTrackerSheet = () => ({
  type: TRACKERS_SHEET_CLOSE,
});
